import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";

export default function ProcessPage({ processKey, onEnquiry, processData }) {
  const page = processData[processKey];
  return (
    <main data-testid={`process-page-${processKey}`}>
      <PageHero eyebrow="How UGI Works" title={page.headline} description={page.intro} testId={`${processKey}-page-hero`}>
        <div className="mt-9 flex flex-wrap items-center gap-4">
          <button data-testid={`${processKey}-page-enquiry-cta`} onClick={onEnquiry} className="inline-flex items-center gap-3 bg-[#C5A059] px-7 py-4 text-xs font-bold tracking-[0.16em] text-[#1C1613] transition-colors hover:bg-[#D4AF37]">
            START AN ENQUIRY <ArrowUpRight size={16} strokeWidth={1.5} />
          </button>
          <span className="text-[11px] font-bold tracking-[0.22em] text-[#E6DED2]">{page.title} · INDIA → GCC → AFRICA → GLOBAL</span>
        </div>
      </PageHero>
      <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
        <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#C5A059]">{page.title}</p>
        <div className="mt-10 grid gap-px border border-[#E5DFD3] bg-[#E5DFD3] md:grid-cols-3">
          {page.sections.map(([title, copy], index) => (
            <article key={title} data-testid={`${processKey}-section-${index + 1}`} className="flex min-h-[300px] flex-col bg-[#FDFBF7] p-8">
              <p className="font-serif text-6xl font-light text-[#C5A059]/35">0{index + 1}</p>
              <h2 className="mt-auto pt-10 font-serif text-3xl font-normal text-[#1C1613]">{title}</h2>
              <p className="mt-4 text-sm leading-7 text-[#524842]">{copy}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
